const Styles = {
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "3.75rem",
  },
  card: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    // boxShadow: "6px 6px 10px #0000001A",
    borderRadius: "6px",
    // padding: "32px",
    // margin: "16px",
  },
  headerContainer: { marginLeft: "32px" },
  headerHeading: {
    color: "#8C8C8C",
    paddingBottom: "16px",
  },
  imageView: {
    background: "#043D902E 0% 0% no-repeat padding-box",
    borderRadius: "50%",
    minHeight: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100px",
    color: "#66697A",
    fontWight: "700",
    fontSize: "24px",
  },
  uploadstyles: {
    paddingLeft: "20px",
  },
  uploadSubtitle: {
    color: "#8C8C8C",
    fontSize: "14px",
    marginTop: "1.2rem",
  },
  formHeading: {
    color: "#8C8C8C",
    fontSize: "20px",
  },
};

export default Styles;
